import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	otherLabel: {
		id: 'issue-field-statistics.services.select-field.transformer.other-label',
		defaultMessage: 'Other',
		description:
			'If there are more than 15 items, the remaining items are grouped under "Other" to ensure the donut chart is readable',
	},
});
